import { combineReducers } from 'redux'

import listBanner from './listBanner'

export default combineReducers({
  listBanner: listBanner
})
